<template>
    <div class="wrapBox">
        <div class="emptyBox colAc" v-if="stuList.length == 0 && isGetData">
            <img src="../../assets/static/emptyList.png" alt="">
            <div>暂时还没有学员哦</div>
        </div>
        <div class="list rowJb" v-else>
            <div class='stuItem' v-for="(item,index) in stuList" :key="index">
                <div class="row rowJbAc">
                    <div class="rowAc">
                        <div class="stuName">{{item.studentName}}</div>
                        <img src="../../assets/static/woman.svg" class="img" alt="" v-if="item.sex == 0">
                        <img src="../../assets/static/man.svg" class="img" alt="" v-if="item.sex == 1">
                    </div>
                    <div class="status rowJcAc" :class="status[item.attendance].bgc">{{status[item.attendance].text}}</div>
                </div>
                <div class="row rowJb">
                    <div class="opacity">{{changePhone(item.parentPhone)}}</div>
                    <div class="opacity relative">({{item.parentRelation}})</div>
                </div>
                <div class="row rowAc">
                    <div class="opacity">{{stuStatus[item.status]}}</div>
                    <img src="../../assets/static/mend.svg" class="iconImg" alt="" v-if="item.origin == 1">
                    <img src="../../assets/static/test.svg" class="iconImg" alt="" v-if="item.origin == 2">
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
import {getCourseStuAPI} from '../../utils/api/api'
export default {
    data() {
        return {
            stuList: [
                // {
                //     attendance: 3,
                //     origin: 0,
                //     parentPhone: "18975756565",
                //     parentRelation: "妈妈",
                //     sex: 0,
                //     status: 1,
                //     studentName: "小白骨",
                // },
            ],
            isGetData: false,
            status: {
                4: {bgc:"unregistered", text: '未登记'}, // 未登录
                0: {bgc: "common",text: '正常'}, // 正常
                3: {bgc: "vacate",text: '请假'}, // 请假
                2: {bgc: "truant",text: '旷课'}, // 旷课
                // 1: {bgc: "late",text: '迟到'}, // 
                5: {bgc: "nomend",text: '待补课'}, //
                6: {bgc: "arrange",text: '已安排'}, // 
                7: {bgc: "mend",text: '已补课'}, // 
                8: {bgc: "pass",text: '已过期'}, // 
            },
            stuStatus: {
                0: "未签约",
                1: "在读",
                2: "停课",
                3: "结课",
            },
        }
    },
    mounted() {
        var childCourseId = this.$route.query.childCourseId
        getCourseStuAPI({childCourseId: childCourseId}).then(res=> {
            console.log("上课学员:",res)
            if(res.resultCode == 200) {
                this.stuList = res.data ? res.data: []
                this.isGetData = true
            }
        })
    },
    methods: {
        changePhone(phone) {
            var str = ''
            if(phone) {

                str += phone.substring(0,3)
                str += '****'
                str += phone.substring(7,11)
            }
            return str
        }
    }
}
</script>
<style lang="scss" scoped>
.common {
    background-color: #24C588;
}
.vacate {
    background-color: #FFBC3A;
}
.truant {
    background-color: #FF7875;
}
.unregistered {
    background-color: #9EA8BA;
}
.nomend {
    background-color:#FFC53D;
}
.arrange {
    background-color:#40A9FF;
}
.mend {
    background-color:#24C588;
}
.pass {
    background-color:#9EA8BA;
}
.wrapBox {
    width: 100%;
    height: 100%;
    overflow: auto;
    box-sizing: border-box;
    padding: 0 .16rem;
    background-color: #F4FAFF;
    
}
// @media screen and (max-width: 360px){
//    .stuItem {
//        width: 100%;
//    } 
// }
// @media screen and (min-width: 360px){
//    .stuItem {
//        width: 163px;
//    } 
// }
.stuItem {
    width: 1.63rem;
    height: .95rem;
    padding: .09rem;
    box-sizing: border-box;
    background: #FFFFFF;
    box-shadow: 4px 4px 11px 0px rgba(229,236,243,0.8), -9px -9px 22px 0px rgba(229,236,243,0.1);
    border-radius: 10px;
    margin-top: 20px;
    .row {
        height: .21rem;
        margin-top: .06rem;
        line-height: .21rem;
    }
    .row:first-child {
        margin-top: 0px;
    }
    .stuName {
        color: #333843;
        font-size: .14rem;
        font-weight: 500;
    }
    .img {
        width: .14rem;
        height: .14rem;
        margin-left: 4px;
    }
    .status {
        width: .48rem;
        height: .21rem;
        border-radius: 10px;
        color: #fff;
        font-size: .12rem;
        text-align: center;
        // line-height: .12rem;
        font-weight: 500;
    }
    .opacity {
        color: #333843;
        opacity: 0.8;
        font-size: .14rem;
    }
    .relative {
        width: .48rem;
        text-align: center;
    }
    .iconImg {
        width: .17rem;
        height: .17rem;
        margin-left: 6px;
    }
}
.list {
    flex-wrap: wrap;
}
.emptyBox {
    img {
        width: 165px;
        height: 114px;
        margin-top: 100px;
    }
    >div {
        font-size: 13px;
        color: #9EA8BA;
        line-height: 19px;
    }
}
</style>